// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.count-block {
    background-color: #60BB46;
    max-width: 227px;
    width: 100%;
    height: 80px;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.search-bar {
    max-width: 240px;
    width: 100%;
}
.search-bar .input-group-text{
    background-color: #FAFAFA;
    
}

.search-bar .form-control {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    border-left: 0;
    background-color: #FAFAFA;
}

.search-bar .input-group-text,
.search-bar .form-control {
    height: 32px;
}

.filter-btn {
    border: 1px solid #E6E6E6;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #4C4C4C;
    background-color: #fff;

}

.userlist-table {
    margin-top: 30px;
}

.userlist-table .thead {
    background-color: #F7F7F7;
    border-radius: 4px 0px;
}

.userlist-table .user-avatar {
    display: flex;
    align-items: center;
}

.userlist-table .avatar-image {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    display: flex;
}

.userlist-table .avatar-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.userlist-table .avatar-image.bordered {
    border: 5px solid #ECECEC;
}

.userlist-table .badge {
    padding: 4px;
    border-radius: 4px;
    gap: 10px;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;

}

.userlist-table {
    background-color: #FCFCFC;
}

.userlist-table .badge.bg-primary {
    background-color: #00863E !important;
    color: #fff;
}

.userlist-table .badge.bg-secondary {
    background-color: #007BB6 !important;
    color: #fff;
}

.userlist-table thead tr {
    background-color: #F7F7F7;
    border-bottom: 1px solid #F2F2F2
}

.userlist-table .thead th {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    background-color: transparent;
}

.userlist-table.table>:not(caption)>*>* {
    background-color: transparent;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #4C4C4C;
}

.userlist-table .user-avatar span {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #808080;
}

.userlist-table .count {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #808080;
}

.pagination-wrapper {
    background: #F7F7F7;
    padding: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.pagination-wrapper .page-link {
    background: #E6E6E6;
    border-radius: 100%;
    margin: 0px 5px;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #4C4C4C;
}

.pagination-wrapper .page-item:last-child .page-link {
    border-radius: 50%;
}

.pagination-wrapper .page-prev.page-item .page-link,
.pagination-wrapper .page-next.page-item .page-link {
    background: unset;
    border: unset;
    color: #4C4C4C;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/admin-dashboard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".count-block {\n    background-color: #60BB46;\n    max-width: 227px;\n    width: 100%;\n    height: 80px;\n    border-radius: 4px;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.search-bar {\n    max-width: 240px;\n    width: 100%;\n}\n.search-bar .input-group-text{\n    background-color: #FAFAFA;\n    \n}\n\n.search-bar .form-control {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    border-left: 0;\n    background-color: #FAFAFA;\n}\n\n.search-bar .input-group-text,\n.search-bar .form-control {\n    height: 32px;\n}\n\n.filter-btn {\n    border: 1px solid #E6E6E6;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #4C4C4C;\n    background-color: #fff;\n\n}\n\n.userlist-table {\n    margin-top: 30px;\n}\n\n.userlist-table .thead {\n    background-color: #F7F7F7;\n    border-radius: 4px 0px;\n}\n\n.userlist-table .user-avatar {\n    display: flex;\n    align-items: center;\n}\n\n.userlist-table .avatar-image {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-right: 10px;\n    display: flex;\n}\n\n.userlist-table .avatar-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.userlist-table .avatar-image.bordered {\n    border: 5px solid #ECECEC;\n}\n\n.userlist-table .badge {\n    padding: 4px;\n    border-radius: 4px;\n    gap: 10px;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n\n}\n\n.userlist-table {\n    background-color: #FCFCFC;\n}\n\n.userlist-table .badge.bg-primary {\n    background-color: #00863E !important;\n    color: #fff;\n}\n\n.userlist-table .badge.bg-secondary {\n    background-color: #007BB6 !important;\n    color: #fff;\n}\n\n.userlist-table thead tr {\n    background-color: #F7F7F7;\n    border-bottom: 1px solid #F2F2F2\n}\n\n.userlist-table .thead th {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    background-color: transparent;\n}\n\n.userlist-table.table>:not(caption)>*>* {\n    background-color: transparent;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #4C4C4C;\n}\n\n.userlist-table .user-avatar span {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #808080;\n}\n\n.userlist-table .count {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #808080;\n}\n\n.pagination-wrapper {\n    background: #F7F7F7;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.pagination-wrapper .page-link {\n    background: #E6E6E6;\n    border-radius: 100%;\n    margin: 0px 5px;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #4C4C4C;\n}\n\n.pagination-wrapper .page-item:last-child .page-link {\n    border-radius: 50%;\n}\n\n.pagination-wrapper .page-prev.page-item .page-link,\n.pagination-wrapper .page-next.page-item .page-link {\n    background: unset;\n    border: unset;\n    color: #4C4C4C;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
